
class Sala {

    constructor (nombre, tipo, salasPosibles, posX, posY){
        
        this.nombre = nombre;
        this.tipo = tipo;
        this.salasPosibles = salasPosibles;
        this.posX = posX;
        this.posY = posY;
    }
}
export {Sala}